var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1564_3243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4989 1.76656H8.2022C8.03077 0.769716 7.12088 0 6.02637 0H5.98681C4.89231 0 3.98242 0.769716 3.81099 1.76656H0.514286C0.224176 1.76656 0 1.98107 0 2.25868C0 2.53628 0.224176 2.75079 0.514286 2.75079H1.26593V9.86751C1.26593 11.0536 2.25495 12 3.49451 12H8.47912C9.71868 12 10.7077 11.0536 10.7077 9.86751V2.75079H11.4857C11.7758 2.75079 12 2.53628 12 2.25868C12 1.98107 11.789 1.76656 11.4989 1.76656ZM6 0.984227H6.03956C6.56703 0.984227 7.01538 1.3123 7.16044 1.76656H4.86593C5.02418 1.3123 5.45934 0.984227 6 0.984227ZM9.71868 9.88013C9.71868 10.5237 9.19121 11.0284 8.51868 11.0284H3.50769C2.83517 11.0284 2.30769 10.5237 2.30769 9.88013V2.75079H9.70549V9.86751H9.71868V9.88013Z",
    fill: "#082E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.45765 9.40073C4.74776 9.40073 4.97193 9.18622 4.97193 8.90862V4.90862C4.97193 4.63101 4.74776 4.4165 4.45765 4.4165C4.16754 4.4165 3.94336 4.63101 3.94336 4.90862V8.90862C3.94336 9.18622 4.16754 9.40073 4.45765 9.40073Z",
    fill: "#082E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56897 9.40073C7.85908 9.40073 8.08326 9.18622 8.08326 8.90862V4.90862C8.08326 4.63101 7.85908 4.4165 7.56897 4.4165C7.27886 4.4165 7.05469 4.63101 7.05469 4.90862V8.90862C7.05469 9.18622 7.30524 9.40073 7.56897 9.40073Z",
    fill: "#082E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1564_3243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.4dabe2c68a029f5a882e4fcae981c4c6.svg";
export { ForwardRef as ReactComponent };